import { HazardType } from '@/features';

export enum SelectedHazardViewType {
  Modal = 'modal',
  Popup = 'popup',
}

export type SelectedHazard = {
  hazardId: string;
  hazardType: HazardType;
  eventId: string;
  viewType?: SelectedHazardViewType;
  /**
   * The feature ID associated with the hazard (if applicable).
   * This can be used to identify a specific GeoJSON feature within a hazard's FeatureCollection.
   */
  featureId?: string;
  fly?: boolean;
};
